import { Link } from '@tanstack/react-router';
import { useId, useState } from 'react';
import { useT } from '../../i18n';
import { dismissWhatsNew, whatsNewDismissed } from '../../lib/whatsNew';

/** "New in Lineage": this release's highlights at the top of the tree list, until dismissed (PRD 11.1). */
export function WhatsNew() {
  const t = useT();
  const id = useId();
  const [open, setOpen] = useState(() => !whatsNewDismissed());
  if (!open) return null;
  const close = () => {
    dismissWhatsNew();
    setOpen(false);
  };
  return (
    <section className="banner whats-new" aria-labelledby={id}>
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <strong id={id}>{t.whatsNew.title}</strong>
        <button type="button" className="btn btn-ghost btn-sm" aria-label={t.common.close} onClick={close}>✕</button>
      </div>
      <ul>
        {t.whatsNew.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <Link to="/settings/$section" params={{ section: 'words' }} className="btn btn-sm" onClick={close}>{t.whatsNew.chooseWords}</Link>
    </section>
  );
}
